import React from "react";
import "../../css/OurTeam.css";

const teamMembers = [
  { firstName: "alexander", lastName: "hum", image: "/AlexanderHum.jpg" },
  { firstName: "emily", lastName: "tang", image: "/EmilyTang.jpg" },
  { firstName: "kieran", lastName: "rourke", image: "/KieranRourke.jpg" },
  { firstName: "nicole", lastName: "lim", image: "/NicoleLim.jpg" },
  { firstName: "vladimir", lastName: "kovacina", image: "/VladimirKovacina.jpg" },
];

const OurTeam = () => {
  return (
    <div className="OurTeam">
      <h1>meet our team</h1>
      <div className="team-members">
        {teamMembers.map((member, index) => (
          <div key={index} className="profile-card">
            <img
              src={member.image}
              alt={`${member.firstName} ${member.lastName}`}
              className="profile-img"
            />
            <h2>
              <span className="first-name">{member.firstName}</span>
              <span className="last-name">{member.lastName}</span>
            </h2>
          </div>
        ))}
      </div>
      <div className="team-info">
        <h2>
          we are a passionate group of software engineering students at carleton
          university dedicated to revolutionizing the dining experience through
          cutting-edge technology. combining our expertise in web development,
          artificial intelligence, and user experience design, we have created a
          state-of-the-art saas platform for restaurants. our goal is to help
          restaurants thrive by enhancing customer engagement and streamlining
          operations with innovative solutions like augmented reality menus and
          ai-driven assistants.
        </h2>
      </div>
    </div>
  );
};

export default OurTeam;
